import { useEffect, useMemo, useRef } from 'react';

import { EModalState } from '../components/LoginModal/LoginModal.types';
import { EToasterStatus, showToast } from '../utils/showToast';
import {
  ResetLinkParamsValidation,
  validateResetLinkParams
} from '../utils/validation/resetLinkParams';

import useUrlQuery from './useUrlQuery';

export const INVALID_RESET_LINK_TOAST_MESSAGE = 'This reset link is invalid.';

type UseResetLinkGuardArgs = {
  setModalState: (state: EModalState) => void;
};

export const useResetLinkGuard = ({
  setModalState
}: UseResetLinkGuardArgs): ResetLinkParamsValidation => {
  const email = useUrlQuery('email');
  const token = useUrlQuery('token');

  const resetLinkValidation = useMemo(
    () => validateResetLinkParams(email, token),
    [email, token]
  );

  const hasNotifiedInvalidResetLinkRef = useRef(false);

  useEffect(() => {
    if (resetLinkValidation.isValid) {
      return;
    }

    if (hasNotifiedInvalidResetLinkRef.current) {
      return;
    }

    hasNotifiedInvalidResetLinkRef.current = true;
    showToast({
      message: INVALID_RESET_LINK_TOAST_MESSAGE,
      status: EToasterStatus.ERROR
    });
    setModalState(EModalState.LOGIN);
  }, [resetLinkValidation.isValid, setModalState]);

  return resetLinkValidation;
};
